import { useMutation } from 'react-query'
import { AxiosError } from 'axios'
import { checkJobInvoices, InvoiceCheckRequest, InvoiceCheckResult } from './invoiceCheckerApi'

export const useInvoiceCheckMutation = () => {
  return useMutation<InvoiceCheckResult, AxiosError, InvoiceCheckRequest>({
    mutationFn: (request: InvoiceCheckRequest) => checkJobInvoices(request),
  })
}
